<template>
  <!--
  <nav class="main-header navbar-white" style="text-align: left; position: absolute; top: 0; left: 0; width: 100%">
    <img style="opacity: 0.8; vertical-align: middle; width: 100px; height: 70px; margin: 5px 5px 5px 5px" src="/dist/img/logo.png" alt="logo" />
    <span style="font-size: 25px; font-weight: bold">Olá, {{ user.apelido }}. Você está no AUDITÓRIO VIRTUAL.</span>

    <a
      href="/user/habilitacoes"
      style="vertical-align: middle; width: 150px; height: 40px; float: right; margin-top: 15px; margin-right: 15px"
      class="btn btn-block btn-info"
      @click="registrarLog('Saiu do auditório')"
    >
      Sair do auditório
    </a>
    <button type="button" id="ativar_audio" class="btn btn-default" style="float: right; margin-left: 10px; margin-top: 15px; margin-right: 15px">
      Áudio
    </button>
    <button type="button" id="ativar_audio" class="btn btn-default" style="float: right; margin-left: 10px; margin-top: 15px; margin-right: 15px">
      Hora atual: {{ data_atual }}
    </button>
  </nav>
  -->

  <a
    v-if="!admin"
    id="sair_auditorio"
    hidden
    href="/user/habilitacoes"
    style="vertical-align: middle; width: 150px; height: 40px; float: right; margin-top: 15px; margin-right: 15px"
    class="btn btn-block btn-info"
    @click="registrarLog('Saiu do auditório')"
  >
    Sair do auditório
  </a>
  <a
    v-else
    id="sair_auditorio"
    hidden
    href="/admin/auditorio"
    style="vertical-align: middle; width: 150px; height: 40px; float: right; margin-top: 15px; margin-right: 15px"
    class="btn btn-block btn-info"
  >
    Sair do auditório
  </a>

  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div :class="getClassAudit()" id="div-audit" v-if="!show_error_msg">
    <!--
    <p class="timertext" style="font-size: 1.5rem">
      Inatividade:
      <span class="secs"></span>
      segundos.
    </p>
    -->

    <!--
    <div class="row" style="width: 100%">
      <div class="col-sm-12" style="font-size: 12px; font-weight: bold">{{ 12 / numero }} por linha</div>
      <div class="col-sm-12">
        <button :class="numero == 6 ? 'btn-brown-yellow' : 'btn-brown'" type="button" class="btn btn-sm" @click="numero = 6">
          <i style="color: black" class="fa-solid fa-table-columns"></i>
        </button>
        <button :class="numero == 3 ? 'btn-brown-yellow' : 'btn-brown'" type="button" class="btn btn-sm" @click="numero = 3">
          <i style="color: black" class="fa-solid fa-table-cells-large"></i>
        </button>
        <button :class="numero == 2 ? 'btn-brown-yellow' : 'btn-brown'" type="button" class="btn btn-sm" @click="numero = 2">
          <i style="color: black" class="fa-solid fa-table-cells"></i>
        </button>
      </div>
      <br />
    </div>
    -->

    <br />
    <h4 v-if="lotes && lotes.length && lotes.length == 1">Lote único</h4>
    <h4 v-else-if="lotes && lotes.length && lotes.length > 1">Lotes de {{ inicio + 1 }} até {{ inicio + lotes.length }}</h4>

    <!-- PAGINAÇÃO  -->
    <ul class="pagination pagination-sm m-0 float-right">
      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

      <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
        <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
          {{ pagina }}
        </a>
      </li>

      <li class="page-item">
        <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
      </li>
      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
    </ul>

    <!-- TABELA DE LOTES -->
    <div class="row" style="width: 100%" id="lotes">
      <div style="min-width: 20%" :class="getClass(lote)" v-for="(lote, indice) in lotes" :key="lote" :value="lote">
        <div class="card" :class="getClassLote(lote)">
          <div class="row p-2" style="min-height: 75px">
            <div class="col-3">
              <img
                :src="getImagePath(lote)"
                style="cursor: pointer; max-height: 60px; max-width: 60px"
                class="im-logo"
                data-toggle="modal"
                data-target="#image-modal"
                @click="selecionarLote(lote)"
              />
            </div>
            <div class="col-7" style="text-align: center">
              <div style="line-height: 15px !important">
                <span class="info-box-text" style="font-size: 18px">Tempo restante</span>
              </div>
              <span
                v-if="lote.lote_status && lote.lote_status == 'ativo'"
                class="info-box-number"
                style="font-size: 18px; color: gray; font-weight: bold; margin-top: -10px"
                :class="lote.tempo >= 0 && lote.tempo <= leilao.leilao_acionar_regressiva_apos ? 'regressiva' : ''"
              >
                {{ getFormatedTitle(lote.tempo_formatado) }}
              </span>
              <span v-else style="color: gray; font-weight: bold; margin-top: -10px">-</span>
            </div>
            <!-- /.col -->
          </div>

          <!--
          <div style="position: absolute; float: left; top: 6px; left: 8px; max-width: 80px">
            <img
              :src="getImagePath(lote)"
              style="cursor: pointer; max-width: 90%; max-height: 70px"
              class="im-logo"
              data-toggle="modal"
              data-target="#image-modal"
              @click="selecionarLote(lote)"
            />
          </div>

          <div style="padding-top: 7px; padding-bottom: 5px; text-align: center; font-size: 18px; border-top: 1px solid #bdbdbd">
            <div style="line-height: 15px !important">
              <span class="info-box-text" style="font-size: 18px">Tempo restante</span>
            </div>
            <span
              v-if="lote.lote_status && lote.lote_status == 'ativo'"
              class="info-box-number"
              style="font-size: 18px; color: gray; font-weight: bold; margin-top: -10px"
              :class="lote.tempo >= 0 && lote.tempo <= leilao.leilao_acionar_regressiva_apos ? 'regressiva' : ''"
            >
              {{ getFormatedTitle(lote.tempo_formatado) }}
            </span>
            <span v-else style="color: gray; font-weight: bold; margin-top: -10px">-</span>
          </div>
          -->

          <div class="meu_ribbon" style="background-color: #bf2e11; padding-inline: 3.3lh" v-if="lote.lote_status == 'retirado'">Retirado</div>
          <div class="meu_ribbon" style="background-color: #301904" v-if="lote.lote_status == 'sem_licitante'">Sem licitante</div>
          <div class="meu_ribbon bg-success" style="padding-inline: 3.3lh" v-if="lote.lote_status == 'vendido'">Vendido</div>

          <!-- 
          <div style="position: absolute; float: right; top: 14px; right: 15px">
            <img
              :src="getHammer(lote)"
              style="cursor: pointer; max-width: 35px; max-height: 30px"
              class="im-logo"
              :title="getTextFavoritos(lote, indice)"
              :alt="getTextFavoritos(lote, indice)"
              @click="addToFavoritos(lote, indice)"
            />
          </div>
          -->

          <div style="line-height: 20px; padding-top: 7px; padding-bottom: 5px; text-align: center; font-size: 18px; border-top: 1px solid #bdbdbd">
            <span class="info-box-text">LOTE {{ lote.lote_numero }}</span>
            <br />
            <span class="info-box-number" style="margin-top: -10px">
              <b :title="lote.lote_titulo" :alt="lote.lote_titulo">{{ getFormatedTitle(lote.lote_titulo) }}</b>
            </span>
            <br />
            <span style="margin-top: -10px; font-size: 14px; color: black">Valor inicial R$ {{ toCurrency(lote.valor_praca_atual) }}</span>
          </div>

          <div style="border-bottom: 1px solid #bdbdbd"></div>
          <div class="card-body" style="position: relative; padding: 5px 5px 5px 5px; text-align: center; font-family: 'Montserrat', sans-serif">
            <div style="text-align: center; line-height: 15px" class="p-2">
              <h5 style="font-weight: bold">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="validarTempoELeilao(lote)"
                  :class="lote.lote_ultimo_lance_parcelado == 0 && lote.lote_lance > 0 ? 'btn-success ' : 'btn-secondary'"
                  :disabled="lote.lote_status"
                >
                  À vista
                </button>

                <!-- CASO PERMITA PARCELADO, ULTIMO LANCE PARCELADO E NÃO TEM PROPOSTA -->
                <span v-if="lote.lote_permitir_parcelamento == 1 && lote.lote_ultimo_lance_parcelado == 1 && !lote.proposta">
                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    @click="validarTempoELeilao(lote)"
                    style="text-decoration: line-through; margin-left: 5px"
                    :disabled="lote.lote_status"
                  >
                    Parcelado
                  </button>

                  <button
                    @click="validarAcaoLanceParcelado(lote)"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 50%; margin-left: 5px; font-size: 12px; font-weight: bold"
                  >
                    ?
                  </button>
                </span>

                <!-- CASO PERMITA PARCELADO, ULTIMO LANCE PARCELADO E TEM PROPOSTA -->
                <button
                  v-else-if="lote.lote_permitir_parcelamento == 1 && lote.lote_ultimo_lance_parcelado == 1 && lote.proposta"
                  type="button"
                  class="btn btn-success btn-sm"
                  @click="validarTempoELeilao(lote)"
                  style="margin-left: 5px"
                  :disabled="lote.lote_status"
                >
                  Parcelado
                </button>

                <!-- CASO PERMITA PARCELADO, MAS NÃO TEM PROPOSTA -->
                <span v-else-if="lote.lote_permitir_parcelamento == 1 && !lote.proposta">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="validarAcaoLanceParcelado(lote)"
                    style="text-decoration: line-through; margin-left: 5px"
                    :disabled="lote.lote_status"
                  >
                    Parcelado
                  </button>

                  <button
                    @click="validarAcaoLanceParcelado(lote)"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 50%; margin-left: 5px; font-size: 12px; font-weight: bold"
                  >
                    ?
                  </button>
                </span>

                <!-- CASO PERMITA PARCELADO, ULTIMO LANCE À VISTA -->
                <span v-else-if="lote.lote_permitir_parcelamento == 1 && lote.lote_ultimo_lance_parcelado == 0 && lote.lote_lance > 0">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="validarAcaoLanceParcelado(lote)"
                    style="text-decoration: line-through; margin-left: 5px"
                    :disabled="lote.lote_status"
                  >
                    Parcelado
                  </button>

                  <button
                    @click="validarAcaoLanceParcelado(lote)"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="border-radius: 50%; margin-left: 5px; font-size: 12px; font-weight: bold"
                  >
                    ?
                  </button>
                </span>

                <!-- CASO PERMITA PARCELADO, E NÃO TENHA LANCE -->
                <button
                  v-else-if="lote.lote_permitir_parcelamento == 1 && lote.lote_lance == 0"
                  type="button"
                  class="btn btn-secondary btn-sm"
                  style="margin-left: 5px"
                  @click="validarTempoELeilao(lote)"
                  :disabled="lote.lote_status"
                >
                  Parcelado
                </button>
              </h5>
              <span style="font-size: 12px; color: black">Maior lance</span>
              <br />

              <a href="#" style="color: black; margin-top: -20px !important">
                <a style="font-size: 18px; font-weight: bold; margin-right: 7px">R$ {{ toCurrency(lotes[indice].lote_lance) }}</a>
                <button type="button" class="btn btn-success btn-sm" :disabled="lote.lote_status">
                  +{{ formatar01CasaDecimal(lotes[indice].lote_comissao) }}%
                </button>
              </a>
              <br />
              <div style="margin-top: 5px !important">
                <button v-if="lote.user_lance" style="font-size: 15px" type="button" class="btn btn-default btn-sm">
                  {{ lote.user_lance }}
                </button>
              </div>

              <button style="font-size: 15px" type="button" class="btn btn-default btn-sm" :class="getApelidoClass(lote)">
                <i class="fa-solid fa-user"></i>
                <a style="margin-left: 5px; font-weight: bold">{{ getApelidoFormatado(lotes[indice].apelido) }}</a>
              </button>

              <span
                style="margin-left: 5px; cursor: pointer"
                @click="showEdp()"
                class="right badge badge-info"
                v-if="lotes[indice].nivel_preferencia_lance"
              >
                EDP {{ lotes[indice].nivel_preferencia_lance }}
              </span>

              <button
                v-if="lote.lote_ultimo_lance_preferencia && lote.lote_ultimo_lance_preferencia == 1"
                @click="showIgualarMsg"
                type="button"
                class="btn btn-default btn-sm"
                style="border-radius: 50%; margin-left: 5px; font-size: 12px; font-weight: bold"
              >
                ?
              </button>
            </div>
          </div>

          <!-- DETALHES DO LANCE -->
          <div v-if="lote.realizar_lance">
            <div class="row p-2">
              <div style="text-align: center" :class="admin && leilao.leilao_1_modalidade == 'simultaneo' ? 'col-6' : 'col-12'">
                <div v-if="lote.lote_lance == 0 || lote.lote_ultimo_lance_parcelado == 1">
                  <span>
                    Confirmar lance inicial
                    <b>À VISTA:</b>
                  </span>

                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    style="color: white; width: 80%"
                    @click="selecionarIncremento(0, 'a_vista', lote)"
                  >
                    R$ {{ toCurrency(lote.valor_praca_atual) }} À VISTA
                  </button>
                </div>
              </div>

              <!-- SIMULTÂNEO-->
              <div v-if="admin && leilao.leilao_1_modalidade == 'simultaneo'" style="text-align: center" class="col-6">
                <div v-if="lote.lote_lance == 0 || lote.lote_ultimo_lance_parcelado == 1">
                  <span>Lance simultâneo</span>

                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    style="color: white; width: 80%"
                    @click="selecionarIncremento(0, 'a_vista', lote), (formData.forma_pagamento = 'a_vista')"
                  >
                    R$ {{ toCurrency(lote.valor_praca_atual) }} À VISTA
                  </button>
                </div>
              </div>
              <div style="text-align: center" :class="admin && leilao.leilao_1_modalidade == 'simultaneo' ? 'col-6' : 'col-12'">
                <div v-if="lote.lote_permitir_parcelamento == 1 && lote.lote_lance == 0" style="margin-top: 10px">
                  <span>
                    Confirmar lance inicial
                    <b>PARCELADO:</b>
                  </span>
                  <button
                    type="button"
                    class="btn btn-sm"
                    style="color: white; width: 80%"
                    @click="selecionarIncremento(0, 'parcelado', lote)"
                    :class="lote.proposta ? 'btn-success' : 'btn-secondary realizado'"
                  >
                    R$ {{ toCurrency(lote.valor_praca_atual) }} PARCELADO
                  </button>
                </div>
              </div>

              <!-- SIMULTÂNEO-->
              <div v-if="admin && leilao.leilao_1_modalidade == 'simultaneo'" style="text-align: center" class="col-6">
                <div v-if="lote.lote_permitir_parcelamento == 1 && lote.lote_lance == 0" style="margin-top: 10px">
                  <span>Lance simultâneo</span>
                  <button
                    type="button"
                    class="btn btn-sm"
                    style="color: white; width: 80%"
                    @click="selecionarIncremento(0, 'parcelado', lote), (formData.forma_pagamento = 'parcelado')"
                    :class="lote.proposta ? 'btn-success' : 'btn-secondary realizado'"
                  >
                    R$ {{ toCurrency(lote.valor_praca_atual) }} PARCELADO
                  </button>
                </div>
              </div>

              <!-- LANCE INCREMENTO À VISTA -->
              <div class="col-12" v-if="lote.lote_lance && lote.lote_lance != 0">
                <div v-if="lote.lote_ultimo_lance_parcelado == 0" style="margin-top: 10px">
                  <!-- SIMULTÂNEO-->
                  <div
                    v-if="admin && leilao.leilao_1_modalidade == 'simultaneo' && lote.lote_ultimo_lance_parcelado == 0"
                    style="text-align: center"
                    class="col-12"
                  >
                    <span>Incremento simultâneo À VISTA</span>

                    <button
                      type="button"
                      class="btn btn-success btn-sm"
                      style="color: white; width: 80%"
                      @click="selecionarIncremento(0, 'a_vista', lote), (formData.forma_pagamento = 'a_vista')"
                    >
                      R$ {{ toCurrency(lote.lote_lance) }} À VISTA
                    </button>
                  </div>

                  <!-- LANCE INCREMENTO À VISTA -->
                  <div v-else>
                    <span>
                      Selecione um incremento
                      <b>À VISTA:</b>
                    </span>

                    <div class="row" style="margin-top: 5px; margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px">
                      <div
                        style="margin-top: 5px; padding: 2px 0px 0px 2px"
                        class="col-4"
                        v-for="incremento in getIncrementos(lote.lote_incrementos)"
                        :key="incremento"
                        :value="incremento"
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          style="color: white; width: 100%"
                          @click="selecionarIncremento(incremento, 'a_vista', lote)"
                        >
                          +R$ {{ formatarMoeda01(incremento) }}
                        </button>
                      </div>

                      <!-- IGUALAR LANCE À VISTA-->
                      <div style="margin-top: 5px; padding: 2px 0px 0px 2px" class="col-4">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          style="color: white; width: 100%"
                          v-if="possuiPrerencia(lote)"
                          @click="selecionarIncremento(0, 'a_vista', lote, true)"
                        >
                          Igualar lance
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- LANCE INCREMENTO PARCELADO -->
                <div
                  v-if="lote.lote_permitir_parcelamento == 1 && lote.lote_lance_user_id != user.id && lote.lote_ultimo_lance_parcelado == 1"
                  style="margin-top: 10px"
                >
                  <!-- SIMULTÂNEO-->
                  <div v-if="admin && leilao.leilao_1_modalidade == 'simultaneo'" style="text-align: center" class="col-6">
                    <div style="margin-top: 10px">
                      <span>Incremento simultâneo PARCELADO</span>
                      <button
                        type="button"
                        class="btn btn-sm"
                        style="color: white; width: 80%"
                        @click="selecionarIncremento(0, 'parcelado', lote), (formData.forma_pagamento = 'parcelado')"
                        :class="lote.proposta ? 'btn-success' : 'btn-secondary realizado'"
                      >
                        R$ {{ toCurrency(lote.valor_praca_atual) }} PARCELADO
                      </button>
                    </div>
                  </div>

                  <!-- LANCE INCREMENTO PARCELADO -->
                  <div v-else>
                    <span>
                      Selecione um incremento
                      <b>PARCELADO:</b>
                    </span>
                    <div class="row" style="margin-top: 5px; margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px">
                      <div
                        class="col-4"
                        style="margin-top: 5px; padding: 2px 0px 0px 2px"
                        v-for="incremento in getIncrementos(lote.lote_incrementos)"
                        :key="incremento"
                        :value="incremento"
                      >
                        <button
                          type="button"
                          class="btn btn-sm"
                          style="color: white; width: 100%"
                          @click="selecionarIncremento(incremento, 'parcelado', lote)"
                          :class="
                            (lote.lote_ultimo_lance_parcelado == 0 && lote.lote_lance != 0) || !lote.proposta
                              ? 'btn-secondary realizado'
                              : 'btn-primary'
                          "
                        >
                          +R$ {{ formatarMoeda01(incremento) }}
                        </button>
                      </div>

                      <!-- IGUALAR LANCE PARCELADO-->
                      <div class="col-4" style="margin-top: 5px; padding: 2px 0px 0px 2px" v-if="possuiPrerencia(lote)">
                        <button
                          type="button"
                          class="btn btn-sm"
                          style="color: white; width: 100%"
                          @click="selecionarIncremento(0, 'parcelado', lote, true)"
                          :class="
                            (lote.lote_ultimo_lance_parcelado == 0 && lote.lote_lance != 0) || !lote.proposta
                              ? 'btn-secondary realizado'
                              : 'btn-primary'
                          "
                        >
                          Igualar lance
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer clearfix" style="text-align: center">
            <div v-if="!lote.realizar_lance">
              <button
                v-if="lote.lote_status == 'retirado'"
                type="button"
                class="btn btn-sm"
                style="width: 150px; font-weight: bold; background-color: #bf2e11"
                disabled
              >
                Lote retirado
              </button>
              <button
                v-else-if="lote.lote_status == 'vendido'"
                type="button"
                class="btn btn-success btn-sm"
                style="width: 150px; font-weight: bold"
                disabled
              >
                Vendido
              </button>
              <button
                v-else-if="lote.lote_status == 'sem_licitante'"
                type="button"
                class="btn btn-info-brown btn-sm"
                style="width: 150px; font-weight: bold"
                disabled
              >
                Sem licitante
              </button>
              <button
                v-else
                type="button"
                class="btn btn-info-brown btn-sm"
                @click="selecionarLoteParaLance(lote), validarTempoELeilao(lote)"
                style="width: 150px; font-weight: bold"
              >
                Selecione um lance
              </button>
            </div>
            <div v-else>
              <button
                style="margin-left: 5px"
                v-if="lote.realizar_lance"
                type="button"
                class="btn btn-danger btn-sm"
                @click="lote.realizar_lance = false"
              >
                Cancelar
              </button>
            </div>

            <!--
            <button style="font-size: 15px" type="button" class="btn btn-default btn-sm">
              <i class="fa-solid fa-bars"></i>
            </button>
            -->
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer clearfix">
      <!-- TOTAIS  -->
      <div style="font-size: 13px" class="float-left" aria-live="polite">
        Exibindo do {{ inicio + 1 }} ao {{ inicio + lotes.length }}
        <p>Total {{ total }}</p>
      </div>

      <!--
      <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

      <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="7">7</option>
        <option :value="15">15</option>
        <option :value="25">25</option>
      </select>
      -->

      <div class="card-tools">
        <div class="input-group input-group-sm" style="width: 150px"></div>
      </div>

      <!-- PAGINAÇÃO 
      <ul class="pagination pagination-sm m-0 float-right">
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

        <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
          <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
            {{ pagina }}
          </a>
        </li>

        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
      </ul>
       -->
    </div>
  </div>

  <div v-if="show_error_msg" style="height: 99vh; margin-top: 3%">
    <p
      style="
        padding: 0 20px;
        margin-left: 0.3em;
        vertical-align: middle;
        background-color: #ffebe8;
        border: solid 1px red;
        width: 100%;
        height: 30px;
        color: red;
      "
    >
      {{ error_msg }}
    </p>
  </div>

  <button id="desconectar-btn" style="display: none; font-size: 15px" type="button" class="btn btn-default btn-sm" @click="desconectar">
    desconectar
  </button>

  <input id="modal_aberto" style="display: none; font-size: 15px" type="button" value="false" />

  <button id="setup-btn" style="display: none; font-size: 15px" type="button" class="btn btn-default btn-sm" @click="setupLeilao">setup</button>

  <!-- MODAL AJUDA-->
  <div class="modal fade" id="info-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #4a4949">
        <div class="modal-body" style="vertical-align: center">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h2>Ajuda da funcionalidade 'Favoritos'</h2>
          <span style="font-size: 17px">Clique no ícone</span>

          <img
            src="https://rochaleiloes.com.br/images/hammer0.png"
            style="max-width: 25px; max-height: 20px; margin-left: 5px; margin-right: 5px"
            class="im-logo"
            title="Favoritar"
            alt="Favoritar"
          />

          <span style="font-size: 17px">
            no topo do lote para adicioná-lo aos favoritos e fixá-los no topo da tela para um acesso mais rápido e prático.
          </span>

          <br />
          <br />
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            data-target="#info-modal"
            style="color: black; font-size: 15px; color: white"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL GALERIA-->
  <div class="modal fade" id="image-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #4a4949">
        <div class="modal-body" v-if="fotos && fotos.length">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <img
            style="position: relative; max-height: 700px; object-fit: contain"
            :src="getImageFoto(foto_selecionada)"
            class="product-image im"
            :alt="foto_selecionada.alt"
          />
          <i
            class="fa-solid fa-angles-right ic"
            style="color: white; cursor: pointer; font-size: 25px; float: right; position: absolute; top: 45%; right: 0px; padding-right: 5px"
            @click="proximaFoto(indice_atual + 1)"
          ></i>

          <i
            class="fa-solid fa-angles-left ic"
            style="color: white; cursor: pointer; font-size: 25px; float: left; position: absolute; top: 45%; left: 0px; padding-left: 5px"
            @click="fotoAnterior(indice_atual - 1)"
          ></i>

          <div class="col-12 product-image-thumbs" style="max-height: 50px">
            <div
              class="product-image-thumb"
              :class="indice == indice_atual ? 'img-t' : ''"
              v-for="(foto, indice) in fotos"
              :key="foto"
              :value="foto"
              @click="selecionarFoto(foto, indice)"
              style="cursor: pointer"
            >
              <img :src="getImageThumb(foto)" alt="Product Image" style="max-height: 40px" />
            </div>
          </div>
        </div>
        <div class="modal-body" v-else>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h2 style="color: black">Lote sem fotos...</h2>
        </div>

        <div class="card-footer" style="background-color: white">
          <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" aria-hidden="true" style="color: black">Fechar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL SELECIONAR LANCE-->
  <div class="modal fade" id="selecionar-lance-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #4a4949">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h4>Selecionar um lance</h4>
          <div class="row">
            <div class="col-12">
              <b>Permite lance parcelado? &nbsp;</b>

              <span v-if="lote_selecionado.lote_permitir_parcelamento == 1 && lote_selecionado.lote_ultimo_lance_parcelado == 0">
                Sim, porém desativado devido a ter recebido lance à vista.
              </span>
              <span v-else-if="lote_selecionado.lote_permitir_parcelamento == 1">Sim</span>
              <span v-else-if="lote_selecionado.lote_permitir_parcelamento == 0">Não</span>
            </div>

            <div class="col-12">
              <br />
            </div>

            <div class="col-6">
              <b>À vista</b>
            </div>

            <div class="col-6">
              <b v-if="lote_selecionado.lote_permitir_parcelamento == 1 && lote_selecionado.lote_ultimo_lance_parcelado == 1">Parcelado</b>
            </div>

            <div :class="lote_selecionado.lote_permitir_parcelamento == 0 || lote_selecionado.lote_ultimo_lance_parcelado == 0 ? 'col-12' : 'col-6'">
              <b>Valor inicial do lote:</b>
              R$ {{ getValorAtual(lote_selecionado) }}
            </div>

            <div class="col-6">
              <b>Valor do último lance:</b>
              R$ {{ toCurrency(lote_selecionado.lote_lance) }}
            </div>

            <div class="col-12">
              <br />
            </div>
            <div class="col-6">
              Selecione um incremento
              <b>À VISTA:</b>
              <div class="row">
                <div class="col-12">
                  <button
                    v-for="incremento in getIncrementos(lote_selecionado.lote_incrementos)"
                    :key="incremento"
                    :value="incremento"
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-dismiss="modal"
                    aria-hidden="true"
                    style="color: white; margin-top: 5px; width: 115px; margin-right: 5px"
                    @click="selecionarIncremento(incremento, 'a_vista')"
                  >
                    +R$ {{ formatarMoeda01(incremento) }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-6"
              v-if="
                lote_selecionado.lote_permitir_parcelamento == 1 &&
                (lote_selecionado.lote_ultimo_lance_parcelado == 1 || lote_selecionado.lote_lance == 0)
              "
            >
              <span>Selecione um lance PARCELADO:</span>
              <div class="row">
                <div class="col-12">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-dismiss="modal"
                    aria-hidden="true"
                    style="color: white; margin-top: 5px; width: 115px"
                    @click="selecionarIncremento(incremento, 'parcelado')"
                    v-for="incremento in getIncrementos(lote_selecionado.lote_incrementos)"
                    :key="incremento"
                    :value="incremento"
                    :disabled="
                      lote_selecionado.lote_permitir_parcelamento == 0 ||
                      (lote_selecionado.lote_permitir_parcelamento == 1 &&
                        lote_selecionado.lote_ultimo_lance_parcelado == 0 &&
                        lote_selecionado.lote_lance != 0)
                        ? true
                        : false
                    "
                  >
                    +R$ {{ formatarMoeda01(incremento) }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn btn-default btn-sm"
            data-dismiss="modal"
            aria-hidden="true"
            style="margin-top: 15px; color: white; color: black"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL LANCE-->
  <div class="modal fade" id="confirmar-lance-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: #4a4949">
        <div class="modal-body">
          <button id="dismiss" type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
          <h4>Confirmação de lance</h4>
          <div class="row">
            <div class="col-12">
              Confirma seu lance na modalidade
              <span style="font-size: 12px" class="btn btn-info-brown" v-if="tipo_lance == 'parcelado'">PARCELADO</span>
              <span style="font-size: 12px" class="btn btn-info-brown" v-else>À VISTA</span>
              conforme condições abaixo?
            </div>
            <div class="col-12"><br /></div>

            <div class="col-12"><br /></div>
          </div>

          <!-- LANCE SIMULTANEO -->
          <div v-if="admin && leilao.leilao_1_modalidade == 'simultaneo'">
            <!-- A VISTA-->
            <div class="form-group" style="width: 100%" v-if="formData.forma_pagamento == 'a_vista'">
              <label for="description">VALOR À VISTA (R$)</label>

              <span style="float: right; margin-left: 5px" v-if="lote_selecionado.lote_permitir_form_proposta_inferior == 0">
                MÍNIMO R$ {{ toCurrency(formData.valor_minimo) }}
              </span>
              <input
                class="form-control"
                v-model="formData.valor_lance_convertido"
                pattern="[0-9][0-9.,]*[0-9]"
                title="Valor válido"
                @blur="formatarValor"
              />

              <span v-if="v$.valor_lance_convertido" style="color: red" v-for="error in v$.valor_lance_convertido.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <!-- PARCELADO -->
            <div class="row" style="width: 100%" v-if="formData.forma_pagamento == 'parcelado'">
              <div class="col-sm-12">
                <label for="description">VALOR</label>

                <span style="float: right; margin-left: 5px" v-if="lote_selecionado.lote_permitir_form_proposta_inferior == 0">
                  MÍNIMO R$ {{ toCurrency(formData.valor_minimo) }}
                </span>
                <input
                  class="form-control"
                  v-model="formData.valor_lance_convertido"
                  pattern="[0-9][0-9.,]*[0-9]"
                  title="Valor válido"
                  @blur="formatarValor"
                />

                <span v-if="v$.valor_lance_convertido" style="color: red" v-for="error in v$.valor_lance_convertido.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
              <div class="col-sm-12"><br /></div>

              <!-- ENTRADA -->
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="description" style="width: 100%">
                    % DE ENTRADA
                    <span style="float: right">R$ {{ toCurrency(this.formData.valor_perc_entrada) }}</span>
                  </label>
                  <div class="input-group mb-3">
                    <input class="form-control" v-model="formData.perc_entrada_formatado" @keyup="calcularEntrada" @blur="formatarEntrada()" />

                    <div class="input-group-append">
                      <div class="input-group-text" id="div-lock" style="background-color: white; border-left: 0px solid #000000 !important">
                        <span id="lock" class="fas fa-percent"></span>
                      </div>
                    </div>
                  </div>

                  <span style="color: red" v-for="error in v$.perc_entrada.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <!-- PARCELAS -->
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="description" style="width: 100%">QTD PARCELAS</label>
                  <select class="custom-select rounded-0" v-model="formData.qtd_parcelas" @change="calcularParcela">
                    <option v-for="parcela in parcelas" :key="parcela" :value="parcela">{{ parcela }}</option>
                  </select>

                  <span style="color: red" v-for="error in v$.qtd_parcelas.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- LANCE AUDITORIO -->
          <div v-if="!admin || leilao.leilao_1_modalidade != 'simultaneo'">
            <div v-if="lote_selecionado.lote_lance || lote_selecionado.lote_lance > 0">
              <div class="col-12">
                Valor atual: R$ {{ toCurrency(formData.valor_lance_atual) }} ({{
                  lote_selecionado.lote_ultimo_lance_parcelado == 1 ? "PARCELADO" : "À VISTA"
                }})
              </div>
              <div class="col-12">Incremento: R$ {{ toCurrency(incremento) }}</div>
              <br />
            </div>

            <div class="col-12">
              <b v-if="lote_selecionado.lote_lance || lote_selecionado.lote_lance > 0">Novo valor:</b>
              <b v-else>Valor inicial:</b>
              R$ {{ toCurrency(valor_lance) }} ({{ (tipo_lance == "parcelado") == 1 ? "PARCELADO" : "À VISTA" }})
            </div>

            <!-- PARCELADO -->
            <div v-if="lote_selecionado.proposta && tipo_lance == 'parcelado'" class="col-12">
              Entrada: {{ formatPct(lote_selecionado.proposta.pct_entrada) }}%
            </div>
            <div v-if="lote_selecionado.proposta && tipo_lance == 'parcelado'" class="col-12">
              Qtd. Parcelas: {{ lote_selecionado.proposta.parcelas }}
            </div>
            <div v-if="lote_selecionado.proposta && tipo_lance == 'parcelado'" class="col-12">
              Índice correção: {{ lote_selecionado.lote_indice_correcao }}
            </div>
            <div v-if="lote_selecionado.proposta && tipo_lance == 'parcelado'" class="col-12">
              Valor aprox. 1º parcela: R$
              {{ toCurrency((valor_lance - (valor_lance * lote_selecionado.proposta.pct_entrada) / 100) / lote_selecionado.proposta.parcelas) }}
            </div>
          </div>

          <!-- SIMULTANEO PARCELADO -->
          <div v-if="admin && leilao.leilao_1_modalidade == 'simultaneo'">
            <!-- PARCELADO -->
            <div v-if="tipo_lance == 'parcelado'" class="col-12">Entrada: {{ formData.perc_entrada_formatado }}%</div>
            <div v-if="tipo_lance == 'parcelado'" class="col-12">Qtd. Parcelas: {{ formData.qtd_parcelas }}</div>
            <div v-if="tipo_lance == 'parcelado'" class="col-12">Índice correção: {{ lote_selecionado.lote_indice_correcao }}</div>
            <div v-if="tipo_lance == 'parcelado'" class="col-12">
              Valor aprox. 1º parcela: R$
              {{ toCurrency((valor_lance - (valor_lance * formData.perc_entrada) / 100) / formData.qtd_parcelas) }}
            </div>
          </div>

          <div class="col-12" v-if="lote_selecionado.lote_comissao && lote_selecionado.lote_comissao > 0">
            Comissão {{ lote_selecionado.lote_comissao }}% : R$ {{ toCurrency((valor_lance * lote_selecionado.lote_comissao) / 100) }}
          </div>
          <div class="col-12" v-if="lote_selecionado.lote_icms && lote_selecionado.lote_icms > 0">
            ICMS: R$ {{ toCurrency((valor_lance * lote_selecionado.lote_icms) / 100) }}
          </div>
          <div class="col-12" v-if="leilao.leilao_taxa_administrativa && leilao.leilao_taxa_administrativa > 0">
            Taxas: R$ {{ toCurrency(leilao.leilao_taxa_administrativa) }}
          </div>
          <div class="col-12">
            <br />
            <b>Total:</b>
            {{ valor_total_lance }}
          </div>

          <button type="button" class="btn btn-success btn-sm" @click="validarLance()" style="margin-top: 5px; color: white">Confirmar lance</button>
          <button
            id="close_lance_modal"
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-top: 5px; color: white; margin-left: 15px"
            data-toggle="modal"
            data-target="#confirmar-lance-modal"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- PAGINAÇÃO  -->
  <ul class="pagination pagination-sm m-0 float-right">
    <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
    <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

    <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
      <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
        {{ pagina }}
      </a>
    </li>

    <li class="page-item">
      <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
    </li>
    <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
  </ul>
</template>

<script>
import auxFormatacao from "../controller/auxFormatacao.js";
import sweetAlert from "../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import currencyController from "../controller/currencyController";
import { socket } from "../socket/socket";
import { socket_lances } from "../socket/socket_lances";
import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, reactive } from "vue";
import { required } from "../locales/i18n.js";

export default {
  props: ["leilao", "user", "habilitacao", "admin"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatacao],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      habilitacao_selecionado: "",
      filtro: "",
      paginas: [],
      habilitacoes: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 60,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      numero: 2,
      socket: "",
      id: 0,
      lotes: [],
      favoritos: [],
      inativo: false,
      ids_favoritos: "",
      max_favoritos: 10,
      fotos: [],
      foto_selecionada: "",
      indice_atual: 0,
      contando: true,
      valor_lance: "",
      lote_selecionado: "",
      incremento: 0,
      tipo_lance: "",
      fav: false,
      browserData: {},
      data_atual: "",
      praca_atual: 0,
      show_error_msg: false,
      error_msg: "",
      setup_inicializado: false,
      igualar_lance: false,
      valor_total_lance: "",
      parcelas: [],
      data_praca_atual: "",
      buscando_lotes: false,
    };
  },

  setup() {
    const formData = reactive({
      termos: "",
      valor: "",
      valor_lance_convertido: "",
      forma_pagamento: "",
      lote_permitir_form_proposta_inferior: "",
      valor_minimo: "",
      valor_perc_entrada: "",
      perc_entrada_formatado: "",
      perc_entrada: "",
      qtd_parcelas: 1,
      valor_lance_atual: "",
    });

    const rules = computed(() => {
      let local_rules = {};

      if (formData.forma_pagamento == "a_vista") {
        local_rules.valor_lance_convertido = {
          required,
          validarMinimo: helpers.withMessage(" O valor do lance está inferior ao valor mínimo do lote nessa praça.", validarMinimo),
          validarMaximo: helpers.withMessage(" O valor do lance precisar ser menor que 9.999.999.999.", validarMaximo),
          validarMinimoLance: helpers.withMessage(" O valor do lance deve ser maior que o maior lance nesse lote.", validarMinimoLance),
        };
      }

      if (formData.forma_pagamento == "parcelado") {
        local_rules.perc_entrada = {
          required,
          validarMaximo: helpers.withMessage(" O valor mínimo de entrada é 0%.", validarEntradaMinimo),
          validarMinimo: helpers.withMessage(" O valor máximo de entrada é 90%.", validarEntradaMaximo),
        };
        local_rules.qtd_parcelas = { required };
        local_rules.valor_lance_convertido = {
          required,
          validarMinimo: helpers.withMessage(" O valor do lance está inferior ao valor mínimo do lote nessa praça.", validarMinimo),
          validarMaximo: helpers.withMessage(" O valor do lance precisar ser menor que 9.999.999.999.", validarMaximo),
          validarMinimoLance: helpers.withMessage(" O valor do lance deve ser maior que o maior lance nesse lote.", validarMinimoLance),
        };
      }

      return local_rules;
    });

    const validarMaximo = (valor) => {
      if (valor && valor > 9999999999) {
        return false;
      } else {
        return true;
      }
    };

    const validarMinimoLance = (valor) => {
      valor = Number(toNumber(valor));
      formData.valor_lance_atual;

      if (valor && valor <= formData.valor_lance_atual) {
        return false;
      } else {
        return true;
      }
    };

    const validarMinimo = (valor) => {
      //console.log("Iniciou");
      valor = Number(toNumber(valor));
      formData.valor_minimo = Number(toNumber(formData.valor_minimo));

      //console.log("Comparando " + typeof valor);
      //console.log(valor);
      //console.log("Com " + typeof formData.valor_minimo);
      //console.log(formData.valor_minimo);

      if ((!valor || valor < formData.valor_minimo || valor == 0) && formData.lote_permitir_form_proposta_inferior == 0) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMinimo = (valor) => {
      console.log("Valor agora " + typeof valor);
      console.log(valor);
      console.log(valor < 0);

      if ((!valor && valor != 0) || valor < 0) {
        return false;
      } else {
        return true;
      }
    };

    const validarEntradaMaximo = (valor) => {
      if (valor >= 90) {
        return false;
      } else {
        return true;
      }
    };

    const toNumber = (value) => {
      if (value) {
        if (typeof value == "number") {
          return value;
        } else {
          //console.log("CONVERTENDO NÃO NUMBER");

          let money = value;

          if (money.charAt(money.length - 2) == ",") {
            money = money + "0";
          }

          money = replaceAll(money, ",", ".");
          money = replaceAll(money, " ", "");

          let possui_decimal = false;

          if (money.length >= 3) {
            possui_decimal = money.charAt(money.length - 3) == ".";

            money = replaceAll(money, ".", "");

            if (possui_decimal) {
              let before = money.substr(0, money.length - 2);
              let after = money.substr(-2, money.length);

              money = before + "." + after;
            }
          }

          return money;
        }
      } else {
        return value;
      }
    };

    const replaceAll = (string, search, replace) => {
      return string.split(search).join(replace);
    };

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Btn?");
    console.log(document.getElementById("dismiss"));
    console.log("Admin?");
    console.log(this.admin);

    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.inicio = this.qtd_por_pagina * (page - 1);
      this.pagina_atual = Number(page);
    }

    if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
      this.praca_atual = 1;
      this.data_praca_atual = this.leilao.leilao_1_data;
    } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
      this.praca_atual = 2;
      this.data_praca_atual = this.leilao.leilao_2_data;
    } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
      this.praca_atual = 3;
      this.data_praca_atual = this.leilao.leilao_3_data;
    } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
      this.praca_atual = 4;
      this.data_praca_atual = this.leilao.leilao_4_data;
    }

    if (this.praca_atual == 0) {
      if (this.leilao.leilao_num_pracas >= 4) {
        this.praca_atual = 4;
        this.data_praca_atual = this.leilao.leilao_4_data;
      } else if (this.leilao.leilao_num_pracas >= 3) {
        this.praca_atual = 3;
        this.data_praca_atual = this.leilao.leilao_3_data;
      } else if (this.leilao.leilao_num_pracas >= 2) {
        this.praca_atual = 2;
        this.data_praca_atual = this.leilao.leilao_2_data;
      } else if (this.leilao.leilao_num_pracas >= 1) {
        this.praca_atual = 1;
        this.data_praca_atual = this.leilao.leilao_1_data;
      }
    }

    let btn = document.getElementById("praca_atual");
    btn.textContent = this.praca_atual + "º praça";

    if (!this.admin && !this.user.profile.magistrado && (!this.habilitacao || this.habilitacao.status != "liberado")) {
      this.showErrorMessageWithButtonAndRedirect("Ops...", "Você não está habilitado para participar deste leilão", "/user/habilitacoes");
      this.show_error_msg = true;
      this.error_msg = "Você não está habilitado para participar deste leilão.";
    }

    if (this.leilao.leilao_retirado == 1) {
      this.show_error_msg = true;
      this.error_msg = "Leilão retirado.";
    }

    if (this.leilao.leilao_encerrado == 1) {
      this.show_error_msg = true;
      this.error_msg = "Leilão encerrado.";
    }

    if (this.leilao.leilao_suspenso == 1) {
      this.show_error_msg = true;
      this.error_msg = "Leilão suspenso.";
    }

    if (this.leilao.leilao_oculto == 1) {
      this.show_error_msg = true;
      this.error_msg = "O leilão não existe.";
    }

    if (this.leilao.leilao_pausado == 1) {
      this.show_error_msg = true;
      this.error_msg = "Leilão pausado.";
    }

    if (!this.show_error_msg) {
      console.log("SEM MENSAGEM DE ERRO");

      //BUSCANDO TERMOS
      //SERÁ SUBSTITUIDO POR UM JOIN QUANDO A TABELA DE DATAS DO LEILÃO FOR USADA POR PADRÃO
      let data = {
        leilao_id: this.leilao.id,
        user_id: this.user.id,
        praca: this.praca_atual,
      };
      /*
      console.log("Buscando termo");
      console.log(data);

      if (!this.admin) {
        axios
          .post("/user/auditorio/termos/search", data)
          .then((response) => {
            if (response.data.termo) {
              console.log("Termo encontrado");
              console.log(response.data.termo);
            } else {
              let html =
                "Para participar do auditório você precisa concordar com os " +
                '<a href="/termos-leiloes-eletronicos" target="_blank">termos e condições.</a>';

              //ACEITAR TERMOS
              this.$swal
                .fire({
                  title: "Termos e condições",
                  inputPlaceholder: "Li e concordo com os Termos e condições.",
                  html: html,
                  icon: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#4caf50",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Concordar",
                  input: "checkbox",
                  inputValidator: (value) => {
                    if (!value) {
                      return "Você precisa concordar com os termos.";
                    }
                  },
                })
                .then((result) => {
                  if (result.value) {
                    this.aceitarTermos();
                  } else {
                    this.isLoading = true;
                    history.back();
                  }
                });
            }
          })
          .catch((error) => {
            this.isLoading = false;

            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
      */

      this.getBrowser();
      this.dataAtual();

      this.registrarLog("Entrou/Recarregou a página");

      console.log("Leilão");
      console.log(this.leilao);
      console.log(this.user);

      this.searchLotes(true);

      socket.connect();
      socket_lances.connect();

      this.isLoading = true;

      //this.isLoading = false;

      socket.on("update_lote", (data) => {
        this.updateLote();
      });

      socket.on("force_disconnect", (data) => {
        console.log("FORCE DISCONNECT");
        console.log(data);

        if (this.leilao.id == data.leilao_id) {
          this.show_error_msg = true;
          this.error_msg = "Sua conexão foi perdida...";
          this.showErrorMessageWithButtonAndReload("Ops...", "Sua conexão foi perdida... Clique em OK para atualizar a tela.");
        }
      });

      socket.on("update_time", (data) => {
        console.log("Tempo atualizado");
        console.log(data);

        //ATUALIZANDO LOTE
        let indice = this.findLote(data.lote_id);

        console.log("Tempo atual");
        console.log(this.lotes[indice].tempo);
        console.log("Novo tempo");
        console.log(data.tempo);

        //AJUSTANDO TEMPO APÓS LANCE
        if (data.tempo >= 0) {
          this.lotes[indice].tempo = data.tempo;
          this.lotes[indice].tempo_formatado = moment().startOf("day").seconds(data.tempo).format("mm:ss");
        }

        //ATUALIZANDO LISTA DE FAVORITOS
        let indice_favorito = this.findLoteFavorito(data.lote_id);

        if (indice_favorito >= 0) {
          //AJUSTANDO TEMPO APÓS LANCE
          if (data.tempo >= 0) {
            this.favoritos[indice_favorito].tempo = data.tempo;
            this.favoritos[indice_favorito].tempo_formatado = moment().startOf("day").seconds(data.tempo).format("mm:ss");
          }
        }
      });

      socket.on("foo", (data) => {
        this.lanceRecebido(data);
      });

      socket_lances.on("foo", (data) => {
        this.lanceRecebido(data);
      });
    } else {
      socket.connect();

      socket.on("force_disconnect", (data) => {
        console.log("FORCE DISCONNECT");
        console.log(data);

        if (this.leilao.id == data.leilao_id) {
          this.show_error_msg = true;
          this.error_msg = "Sua conexão foi perdida...";
          this.showErrorMessageWithButtonAndReload("Ops...", "Sua conexão foi perdida... Clique em OK para atualizar a tela.");
        }
      });
    }
  },

  methods: {
    lanceRecebido(data) {
      console.log("Foo recebido, último lance");
      console.log(data);
      console.log(data.ultimo_lance_id);

      //ATUALIZANDO LISTA DE LOTES
      let indice = this.findLote(data.lote_id);

      let notificacao_enviada = false;

      if (data.lote_id == this.lote_selecionado.id && data.user_id != this.user.id) {
        let modal_aberto = document.getElementById("modal_aberto");
        console.log(modal_aberto);
        console.log(modal_aberto.value);

        if (modal_aberto.value == "true") {
          let that = this;

          this.$swal
            .fire({
              icon: "error",
              title: "Ops...",
              padding: "1.5em",
              text: "Outro usuário acabou de dar lance nesse lote. Clique em OK para atualizar a sua tela e tentar novamente.",
            })
            .then(function () {
              //that.show_error_msg = true;
              //that.error_msg = "Outro usuário acabou de dar lance nesse lote. Sua tela será atualizada imediatamente.";
              //that.isLoading = true;
              //window.location.href = "/user/auditorio/" + that.leilao.id;
            });

          let btn = document.getElementById("dismiss");

          console.log("CLICOU NO DISMISS?");

          if (btn) {
            console.log("SIM");
            btn.click();
          } else {
            console.log("NÃO");
          }
        }
      } else {
        console.log("LOTE ID " + data.lote_id);
        console.log("LOTE selecionado " + this.lote_selecionado.id);
      }

      if (indice >= 0) {
        console.log("Indice normal");

        this.lotes[indice].ultimo_lance_id = data.ultimo_lance_id;
        this.lotes[indice].lote_ultimo_lance_preferencia = data.igualar_lance ? 1 : 0;

        if (data.igualar_lance) {
          this.lotes[indice].nivel_preferencia_lance = data.preferencia_user_novo_lance;
        } else {
          this.lotes[indice].nivel_preferencia_lance = null;
        }

        //AJUSTANDO TEMPO APÓS LANCE
        if (data.tempo >= 0) {
          this.lotes[indice].tempo = data.tempo;
          this.lotes[indice].tempo_formatado = moment().startOf("day").seconds(data.tempo).format("mm:ss");
        }

        this.lotes[indice].animate = true;
        this.lotes[indice].lote_lance = data.valor;
        this.lotes[indice].lote_ultimo_lance_parcelado = data.parcelado;

        let mensagem = data.apelido + " deu lance de R$" + this.toCurrency(data.valor) + " no lote " + this.lotes[indice].lote_numero;

        document.getElementById("my_toast_msg").value = mensagem;
        document.getElementById("btn_toast").click();

        notificacao_enviada = true;

        console.log("Meu id " + this.user.id);
        console.log("Id no LOTE " + this.lotes[indice].lote_lance_user_id);
        console.log("Id no data " + data.user_id);

        let btn_audio = document.getElementById("play_audio");
        btn_audio.click();

        this.lotes[indice].class = "pulse";

        this.lotes[indice].lote_lance_user_id = data.user_id;
        this.lotes[indice].apelido = data.apelido;

        console.log("2Id no LOTE " + this.lotes[indice].lote_lance_user_id);

        let that = this;

        this.id++;

        console.log("Setando lote " + data.lote_id);
        console.log("Indice " + indice);
        console.log("Valor " + data.valor);
        console.log("Final ");
        console.log(this.lotes[indice]);

        setTimeout(() => {
          that.lotes[indice].animate = false;
          console.log("\n\n\nLote false");
          console.log(indice);
          this.lotes[indice].class = "";
          that.id++;
        }, 4000);
      } else {
        console.log("Não encontrado na lista de lotes");
      }

      //ATUALIZANDO LISTA DE FAVORITOS
      let indice_favorito = this.findLoteFavorito(data.lote_id);

      if (indice_favorito >= 0) {
        console.log("LOTE FAVORITO " + indice_favorito);

        this.favoritos[indice_favorito].ultimo_lance_id = data.ultimo_lance_id;
        this.favoritos[indice_favorito].lote_ultimo_lance_preferencia = data.igualar_lance ? 1 : 0;

        if (data.igualar_lance) {
          this.favoritos[indice_favorito].nivel_preferencia_lance = data.preferencia_user_novo_lance;
        } else {
          this.favoritos[indice_favorito].nivel_preferencia_lance = null;
        }

        //AJUSTANDO TEMPO APÓS LANCE
        if (data.tempo >= 0) {
          this.favoritos[indice_favorito].tempo = data.tempo;
          this.favoritos[indice_favorito].tempo_formatado = moment().startOf("day").seconds(data.tempo).format("mm:ss");
        }

        if (!notificacao_enviada) {
          let mensagem = data.apelido + " deu lance de R$" + this.toCurrency(data.valor) + " no lote " + this.favoritos[indice_favorito].lote_numero;

          document.getElementById("my_toast_msg").value = mensagem;
          document.getElementById("btn_toast").click();
        }

        this.favoritos[indice_favorito].animate = true;
        this.favoritos[indice_favorito].lote_lance = data.valor;
        this.favoritos[indice_favorito].lote_ultimo_lance_parcelado = data.parcelado;

        console.log("Meu id " + this.user.id);
        console.log("Id no LOTE " + this.favoritos[indice_favorito].lote_lance_user_id);
        console.log("Id no data " + data.user_id);

        let btn_audio = document.getElementById("play_audio");
        btn_audio.click();

        this.favoritos[indice_favorito].class = "pulse";

        this.favoritos[indice_favorito].lote_lance_user_id = data.user_id;
        this.favoritos[indice_favorito].apelido = data.apelido;

        console.log("2Id no LOTE " + this.favoritos[indice_favorito].lote_lance_user_id);

        let that = this;

        this.id++;

        console.log("Setando lote " + data.lote_id);
        console.log("Indice " + indice_favorito);
        console.log("Valor " + data.valor);
        console.log("Final ");
        console.log(this.favoritos[indice_favorito]);

        setTimeout(() => {
          console.log("\n\n\nLote false favoritos");
          this.favoritos[indice_favorito].class = "";
          that.id++;
        }, 4000);
      }
    },

    showEdp() {
      this.$swal.fire({
        icon: "info",
        title: "EDP",
        padding: "1.5em",
        text: "EDP = Exercício de Direito de Preferência",
      });
    },

    getApelidoFormatado(apelido) {
      if (apelido && apelido != this.user.apelido) {
        if (apelido.length < 6 && apelido.length >= 3) {
          let apelido_formatado = apelido.substring(0, 2);

          for (let i = 2; i < apelido.length; i++) {
            apelido_formatado = apelido_formatado + "*";
          }

          apelido_formatado = apelido_formatado + apelido.substring(apelido.length - 1, apelido.length);

          return apelido_formatado;
        } else if (apelido.length >= 6) {
          let apelido_formatado = apelido.substring(0, 2);

          for (let i = 2; i < apelido.length - 1; i++) {
            apelido_formatado = apelido_formatado + "*";
          }

          apelido_formatado = apelido_formatado + apelido.substring(apelido.length - 1, apelido.length);

          return apelido_formatado;
        } else if (apelido.length < 3) {
          let apelido_formatado = apelido.substring(0, 1);

          for (let i = 1; i < apelido.length; i++) {
            apelido_formatado = apelido_formatado + "*";
          }

          return apelido_formatado;
        }
      } else {
        return apelido;
      }
    },

    /*
    getApelidoFormatado(apelido) {
      if (apelido && apelido != this.user.apelido) {
        if (apelido.length < 6 && apelido.length >= 3) {
          let apelido_formatado = apelido.substring(0, 1);

          for (let i = 2; i < apelido.length; i++) {
            apelido_formatado = apelido_formatado + "*";
          }

          apelido_formatado = apelido_formatado + apelido.substring(apelido.length - 1, apelido.length);

          return apelido_formatado;
        } else if (apelido.length >= 6) {
          let apelido_formatado = apelido.substring(0, 2);

          for (let i = 2; i < apelido.length - 2; i++) {
            apelido_formatado = apelido_formatado + "*";
          }

          apelido_formatado = apelido_formatado + apelido.substring(apelido.length - 2, apelido.length);

          return apelido_formatado;
        }
      } else {
        return apelido;
      }
    },
    */

    formatarEntrada() {
      this.formData.perc_entrada_formatado = this.toCurrency(this.formData.perc_entrada_formatado);
    },

    alterarValorProposta() {
      this.valor_lance = Number(this.toNumber(this.formData.valor_lance_convertido));
      this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);

      this.calcularEntrada();
    },

    formatarValor() {
      this.valor_lance = Number(this.toNumber(this.formData.valor_lance_convertido));
      this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);

      console.log("FORMATADO");
      console.log(this.formData.valor_lance_convertido);
      console.log(this.valor_lance);
      console.log(this.formData.forma_pagamento);

      this.getValorTotal();
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    calcularEntrada() {
      this.formData.perc_entrada = Number(this.toNumber(this.formData.perc_entrada_formatado));

      this.calcularParcela();
      this.formData.valor_perc_entrada = (this.formData.perc_entrada * this.formData.valor_lance_convertido) / 100;
    },

    calcularParcela() {
      let valor_entrada = (this.formData.perc_entrada * this.formData.valor_proposta_convertido) / 100;

      this.formData.valor_qtd_parcelas = this.toCurrency((this.formData.valor_proposta_convertido - valor_entrada) / this.formData.qtd_parcelas);
      console.log(this.formData.valor_qtd_parcelas);
    },

    getPctEntrada(lote) {
      if (lote.proposta) {
        return this.formatPct(lote.proposta.pct_entrada);
      } else {
        return formatPct(lote_selecionado.lote_pct_entrada);
      }
    },

    showIgualarMsg() {
      this.$swal
        .fire({
          icon: "info",
          title: "Lance igualado",
          padding: "1.5em",
          text: "Esse usuário tem preferência, então teve permissão de igualar ao último lance dado.",
        })
        .then(function () {
          window.location.href = href;
        });
    },

    possuiPrerencia(lote) {
      let array_preferenciais = [];

      if (lote.lotes_ids_cliente_lance_pref_prio_maior) {
        array_preferenciais = array_preferenciais.concat(lote.lotes_ids_cliente_lance_pref_prio_maior.split(";"));
      }

      if (lote.lotes_ids_cliente_lance_pref_prio_media) {
        array_preferenciais = array_preferenciais.concat(lote.lotes_ids_cliente_lance_pref_prio_media.split(";"));
      }

      if (lote.lotes_ids_cliente_lance_pref_prio_menor) {
        array_preferenciais = array_preferenciais.concat(lote.lotes_ids_cliente_lance_pref_prio_menor.split(";"));
      }

      if (array_preferenciais) {
        let indice = array_preferenciais.findIndex((element) => element == this.user.id);

        if (indice >= 0) {
          return true;
        }
      }
      return false;
    },

    validarTempoELeilao(lote) {
      let data = {
        leilao_id: this.leilao.id,
        lote_id: lote.id,
        user_id: this.user.id,
        praca: this.praca_atual,
      };

      console.log("Validando tempo e leilão");
      console.log(data);

      axios
        .post(process.env.MIX_VUE_APP_AUDITORIO_LANCE + `/validate_time_and_leilao`, data)
        .then((response) => {
          console.log("Response");
          console.log(response.data);

          if (response.data.status == "Ok") {
            if (response.data.leilao_finalizado) {
              this.showErrorMessageWithButton("Ops...", "Esse lote não está mais disponível.");
            } else if (!response.data.time || response.data.time <= 0) {
              this.showErrorMessageWithButton("Ops...", "Esse lote não está mais disponível, pois o tempo acabou.");

              //PERMITE DAR LANCE SE FOR À VISTA
            } else if (lote.lote_lance_user_id == this.user.id && lote.lote_ultimo_lance_parcelado == 0) {
              this.showErrorMessageWithButton("Ops...", "Esse lance não é permitido, pois o último lance já pertence ao seu usuário.");
            } else {
              lote.realizar_lance = true;
            }
          } else {
            this.showErrorMessageWithButton("Ops...", "Erro no lote");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          //window.location.reload();

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatPct(texto) {
      return this.replaceAll(texto, ".", ",");
    },

    replaceAll(string, search, replace) {
      if (typeof string == "string") {
        return string.split(search).join(replace);
      } else {
        return string;
      }
    },

    getValorAtual(lote) {
      if (lote) {
        if (this.praca_atual == 1) {
          return this.toCurrency(lote.lote_valor_1);
        } else if (this.praca_atual == 2) {
          return this.toCurrency(lote.lote_valor_2);
        } else if (this.praca_atual == 3) {
          return this.toCurrency(lote.lote_valor_3);
        } else if (this.praca_atual == 4) {
          return this.toCurrency(lote.lote_valor_4);
        }
      }
    },

    aceitarTermos() {
      let data = {
        leilao_id: this.leilao.id,
        user_id: this.user.id,
        praca: this.praca_atual,
      };

      console.log("Aceitando termos");
      console.log(data);

      axios
        .post("/user/auditorio/termos", data)
        .then((response) => {
          console.log("Termos aceitos");
        })
        .catch((error) => {
          this.isLoading = false;
          //window.location.reload();

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getValorTotal() {
      console.log("CALCULANDO VALOR");

      let icms = Number(parseFloat((this.valor_lance * this.lote_selecionado.lote_icms) / 100).toFixed(2));

      console.log("ICMS");
      console.log(icms);

      console.log("Valor lance");
      console.log(Number(this.valor_lance));

      let taxa_adm = Number(parseFloat(this.leilao.leilao_taxa_administrativa).toFixed(2));

      console.log("Taxa adm");
      console.log(taxa_adm);

      let comissao = Number(parseFloat((this.valor_lance * this.lote_selecionado.lote_comissao) / 100).toFixed(2));

      console.log("Comissão");
      console.log(comissao);

      console.log("VALOR + COMISSÃO");
      console.log(this.valor_lance + comissao);

      console.log("ICMS + TAXA");
      console.log(icms + taxa_adm);

      console.log("TOTAL");
      console.log(this.valor_lance + comissao + icms + taxa_adm);
      console.log("R$" + this.toCurrency(this.valor_lance + comissao + icms + taxa_adm));

      /*
      let valor =
        (this.valor_lance * this.lote_selecionado.lote_icms) / 100 +
        Number(this.valor_lance) +
        Number(this.leilao.leilao_taxa_administrativa) +
        (this.valor_lance * this.lote_selecionado.lote_comissao) / 100;

      console.log(valor);
      */

      this.valor_total_lance = "R$" + this.toCurrency(this.valor_lance + comissao + icms + taxa_adm);
    },

    dataAtual() {
      setTimeout(() => {
        let btn = document.getElementById("hora_atual");
        btn.textContent = "Data atual: " + moment(new Date()).format("DD/MM/YYYY");
        this.dataAtual();
      }, 1000);
    },

    getBrowser() {
      console.log("Navegador");

      // browser
      var nVer = window.navigator.appVersion;
      var nAgt = window.navigator.userAgent;
      var browser = window.navigator.appName;
      var version = "" + parseFloat(nVer);
      var nameOffset, verOffset, ix;

      // Yandex Browser
      if ((verOffset = nAgt.indexOf("YaBrowser")) != -1) {
        browser = "Yandex";
        version = nAgt.substring(verOffset + 10);
      }
      // Samsung Browser
      else if ((verOffset = nAgt.indexOf("SamsungBrowser")) != -1) {
        browser = "Samsung";
        version = nAgt.substring(verOffset + 15);
      }
      // UC Browser
      else if ((verOffset = nAgt.indexOf("UCBrowser")) != -1) {
        browser = "UC Browser";
        version = nAgt.substring(verOffset + 10);
      }
      // Opera Next
      else if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
      }
      // Opera
      else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Legacy Edge
      else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
        browser = "Microsoft Legacy Edge";
        version = nAgt.substring(verOffset + 5);
      }
      // Edge (Chromium)
      else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 4);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf("Trident/") != -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
      }
      // Other browsers
      else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
          browser = window.navigator.appName;
        }
      }
      // trim the version string
      if ((ix = version.indexOf(";")) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(" ")) != -1) version = version.substring(0, ix);
      if ((ix = version.indexOf(")")) != -1) version = version.substring(0, ix);

      let majorVersion = parseInt("" + version, 10);
      if (isNaN(majorVersion)) {
        version = "" + parseFloat(nVer);
        majorVersion = parseInt(nVer, 10);
      }

      // mobile version
      var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

      // cookie
      var cookieEnabled = window.navigator.cookieEnabled ? true : false;

      if (typeof window.navigator.cookieEnabled == "undefined" && !cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") != -1 ? true : false;
      }

      // system
      var os = "-";
      var clientStrings = [
        { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
        { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
        { s: "Windows Vista", r: /Windows NT 6.0/ },
        { s: "Windows Server 2003", r: /Windows NT 5.2/ },
        { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
        { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
        { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
        { s: "Windows 98", r: /(Windows 98|Win98)/ },
        { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
        { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: "Windows CE", r: /Windows CE/ },
        { s: "Windows 3.11", r: /Win16/ },
        { s: "Android", r: /Android/ },
        { s: "Open BSD", r: /OpenBSD/ },
        { s: "Sun OS", r: /SunOS/ },
        { s: "Chrome OS", r: /CrOS/ },
        { s: "Linux", r: /(Linux|X11(?!.*CrOS))/ },
        { s: "iOS", r: /(iPhone|iPad|iPod)/ },
        { s: "Mac OS X", r: /Mac OS X/ },
        { s: "Mac OS", r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: "QNX", r: /QNX/ },
        { s: "UNIX", r: /UNIX/ },
        { s: "BeOS", r: /BeOS/ },
        { s: "OS/2", r: /OS\/2/ },
        { s: "Search Bot", r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
      ];
      for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
          os = cs.s;
          break;
        }
      }

      var osVersion = "-";

      if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
      }

      switch (os) {
        case "Mac OS":
        case "Mac OS X":
        case "Android":
          osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
          break;

        case "iOS":
          osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
          osVersion = osVersion[1] + "." + osVersion[2] + "." + (osVersion[3] | 0);
          break;
      }

      // flash (you'll need to include swfobject)
      /* script src="//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js" */
      var flashVersion = "no check";
      if (typeof swfobject != "undefined") {
        var fv = swfobject.getFlashPlayerVersion();
        if (fv.major > 0) {
          flashVersion = fv.major + "." + fv.minor + " r" + fv.release;
        } else {
          flashVersion = "-";
        }
      }

      let device = "Unknown";

      const ua = {
        "Generic Linux": /Linux/i,
        Android: /Android/i,
        BlackBerry: /BlackBerry/i,
        Bluebird: /EF500/i,
        "Chrome OS": /CrOS/i,
        Datalogic: /DL-AXIS/i,
        Honeywell: /CT50/i,
        iPad: /iPad/i,
        iPhone: /iPhone/i,
        iPod: /iPod/i,
        macOS: /Macintosh/i,
        Windows: /IEMobile|Windows/i,
        Zebra: /TC70|TC55/i,
      };
      Object.keys(ua).map((v) => navigator.userAgent.match(ua[v]) && (device = v));

      let jscd = {
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        device: device,
        os: os,
        osVersion: osVersion,
        cookies: cookieEnabled,
        flashVersion: flashVersion,
      };

      this.browserData.dispotivo = device;
      this.browserData.plataforma = jscd.os;
      this.browserData.navegador = jscd.browser;

      console.log("OBJ BROWSER");
      console.log(this.browserData);

      /*
      console.log(
        "OS: " +
          jscd.os +
          " " +
          jscd.osVersion +
          "\n" +
          "Browser: " +
          jscd.browser +
          " " +
          jscd.browserMajorVersion +
          " (" +
          jscd.browserVersion +
          ")\n" +
          "Mobile: " +
          jscd.mobile +
          "\n" +
          "Flash: " +
          jscd.flashVersion +
          "\n" +
          "Cookies: " +
          jscd.cookies +
          "\n" +
          "Screen Size: " +
          jscd.screen +
          "\n\n" +
          "Full User Agent: " +
          window.navigator.userAgent
      );
      */
    },

    registrarLog(acao, lote_id) {
      let user_agent =
        "DISPOSITIVO: " +
        this.browserData.dispotivo +
        "<br/>" +
        "PLATAFORMA: " +
        this.browserData.plataforma +
        "<br/>" +
        "NAVEGADOR: " +
        this.browserData.navegador +
        "<br/>";

      let data = {
        leilao_id: this.leilao.id,
        log: acao,
        user_agent: user_agent,
      };

      if (lote_id) {
        data.lote_id = lote_id;
      }

      console.log(data);

      axios
        .post("/user/auditorio/actions/store", data)
        .then((response) => {})
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
        });
    },

    enviarLance() {
      this.isLoading = true;
      console.log("isLoading no enviar lance");

      let valor_lance = 0;
      let valor_antes = 0;

      if (this.fav) {
        let indice = this.findLoteFavorito(this.lote_selecionado.id);
        valor_antes = this.favoritos[indice].lote_lance;
        this.lote_selecionado = this.favoritos[indice];
      } else {
        let indice = this.findLote(this.lote_selecionado.id);
        valor_antes = this.lotes[indice].lote_lance;
        this.lote_selecionado = this.lotes[indice];
      }

      console.log("Lote encontrado ");
      console.log(this.lote_selecionado);

      if (this.admin && this.leilao.leilao_1_modalidade == "simultaneo") {
        valor_lance = this.valor_lance;
        //LANCE INICIAL
      } else if ((!this.lote_selecionado.lote_lance || this.lote_selecionado.lote_lance == 0) && this.incremento == 0) {
        console.log("Enviando lote lance 2");
        valor_lance = Number(this.lote_selecionado.valor_praca_atual) + Number(this.incremento);
      } else if (this.lote_selecionado.lote_lance && this.lote_selecionado.lote_lance > 0 && this.incremento > 0) {
        console.log("Enviando lote lance 1");
        valor_lance = Number(this.lote_selecionado.lote_lance) + Number(this.incremento);
      } else if (
        this.lote_selecionado.lote_lance &&
        this.lote_selecionado.lote_lance > 0 &&
        this.incremento == 0 &&
        this.lote_selecionado.lote_ultimo_lance_parcelado == 1 &&
        this.tipo_lance == "a_vista"
      ) {
        console.log("Enviando lote lance 3 igualar");
        valor_lance = Number(this.lote_selecionado.valor_praca_atual) + Number(this.incremento);
        this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);

        //IGUALAR
      } else if (this.lote_selecionado.lote_lance && this.lote_selecionado.lote_lance > 0 && this.incremento == 0) {
        console.log("Enviando lote lance 3 - IGUALAR");
        valor_lance = Number(this.lote_selecionado.lote_lance) + Number(this.incremento);
      }

      this.valor_lance = valor_lance;

      let possui_preferencia = this.possuiPrerencia(this.lote_selecionado);

      let data = {
        praca_atual: this.praca_atual,
        ultimo_lance_id: this.lote_selecionado.ultimo_lance_id,
        lote_id: this.lote_selecionado.id,
        leilao_id: this.leilao.id,
        user_id: this.user.id,
        valor: valor_lance,
        parcelado: this.tipo_lance == "parcelado" ? 1 : 0,
        incremento: this.incremento,
        ip: "1234",
        apelido: this.user.apelido,
        possui_preferencia: possui_preferencia ? 1 : 0,
        igualar_lance: this.igualar_lance ? true : false,
        praca: this.praca_atual,
        data_praca_atual: this.data_praca_atual,
      };

      console.log(data);

      axios
        .post(process.env.MIX_VUE_APP_AUDITORIO_LANCE + `/lance`, data)
        .then((response) => {
          if (response.data.status == "Error") {
            this.isLoading = false;

            if (response.data.refresh) {
              this.showErrorMessageWithButtonAndReloadIfConfirm("Ops...", response.data.message);
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.message);
            }

            let btn = document.getElementById("close_lance_modal");

            if (btn) {
              btn.click();
            }

            let indice = this.findLote(this.lote_selecionado.id);

            if (indice >= 0) {
              this.lotes[indice].realizar_lance = false;
            }
          } else {
            console.log(response);
            this.isLoading = false;

            //this.showSuccessMessageWithButton("Sucesso", "Lance enviado com sucesso!");

            //VERIFICAR SE FOI LANCE PRÉ
            var data_agora = moment(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }), "MM-DD-YYYY HH:mm:ss A");
            let data_atual = moment(this.data_praca_atual);

            if (data_atual.format("DD/MM/yyyy HH:mm:ss") != "Invalid date") {
              if (data_agora.isBefore(data_atual) && !this.admin) {
                console.log("GERANDO E-MAIL");
                console.log(this.leilao);

                let categoria = this.lote_selecionado.categoria ? this.lote_selecionado.categoria.nome + "<br/>" : "";
                let tipo_lance = this.tipo_lance == "a_vista" ? "À VISTA " : "PARCELADO";

                console.log("Categoria? " + categoria);

                let style =
                  'style="margin-top:5px;cursor: pointer;' +
                  "outline: 0;" +
                  "color: #fff;" +
                  "background-color: #2d3748;" +
                  "border-color: #2d3748;" +
                  "display: inline-block;" +
                  "font-weight: 400;" +
                  "line-height: 1.5;" +
                  "text-align: center;" +
                  "border: 1px solid transparent;" +
                  "padding: 6px 12px;" +
                  "font-size: 16px;" +
                  "border-radius: .25rem;" +
                  'transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;"';

                let link =
                  '<a target="_blank" ' +
                  style +
                  ' class="btn btn-primary" href="' +
                  process.env.MIX_VUE_APP_URL +
                  "/lote/" +
                  this.lote_selecionado.id +
                  '">Abrir</a>';

                console.log("LINK");
                console.log(link);

                let corpo_email =
                  "<h3>NOVO LANCE " +
                  tipo_lance +
                  "</h3>" +
                  "Por: " +
                  this.user.apelido +
                  "<br/>" +
                  this.leilao.cidade.nome +
                  "/" +
                  this.leilao.estado.sigla +
                  "<br/> " +
                  categoria +
                  "<br/> " +
                  "LEILÃO " +
                  this.leilao.id +
                  " - " +
                  this.leilao.leilao_titulo +
                  " " +
                  this.leilao.comitente.nome +
                  "<br/>" +
                  "LOTE " +
                  this.lote_selecionado.lote_numero +
                  " - " +
                  this.lote_selecionado.lote_titulo +
                  "<br/>" +
                  "PRAÇA: " +
                  this.praca_atual +
                  "º<br/>" +
                  "INCREMENTO: R$ " +
                  this.toCurrency(this.incremento) +
                  "<br/>" +
                  "VALOR DO LANCE: R$ " +
                  this.toCurrency(valor_lance) +
                  "<br/>" +
                  "IP: " +
                  response.data.ip +
                  " <br/>" +
                  "HORA DO LANCE: " +
                  data_agora.format("DD-MM-yyyy HH:mm:ss");

                //corpo_email = corpo_email.toUpperCase();
                corpo_email = corpo_email + "<br/>" + link;

                let data = {
                  corpo_email: corpo_email,
                };

                console.log("ENVIANDO E-MAIL");
                console.log(data);

                axios
                  .post("/user/lance/send_email", data)
                  .then((response) => {
                    console.log("EMAIL ENVIADO!");
                  })
                  .catch((error) => {
                    this.isLoading = false;
                    console.log("Erro");
                    console.log(error);
                    this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                  });
              }
            } else {
              console.log("Falha no envio do e-mail");
            }

            let btn = document.getElementById("close_lance_modal");
            btn.click();

            let indice = this.findLote(this.lote_selecionado.id);

            if (indice >= 0) {
              this.lotes[indice].realizar_lance = false;
            }
            let indice_favorito = this.findFavoritoFromFavoritos(this.lote_selecionado.id);

            if (indice_favorito > 0) {
              this.favoritos[indice_favorito].realizar_lance = false;
            }

            this.registrarLog(
              "Deu lance de R$" + this.toCurrency(valor_lance) + " no lote Nº" + this.lote_selecionado.lote_numero,
              this.lote_selecionado.lote_id
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("Erro");
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
        });
    },

    validarAcaoLanceParcelado(lote) {
      if (lote.lote_status != "retirado") {
        if (lote.lote_permitir_parcelamento == 1 && lote.lote_lance > 0 && lote.lote_ultimo_lance_parcelado == 0) {
          let texto = "Não é mais permitido enviar lance parcelado pois já teve lance à vista para esse lote.";

          this.$swal
            .fire({
              title: "Ops",
              text: texto,
              icon: "info",
            })
            .then((result) => {});
        } else if (!lote.proposta) {
          let texto =
            'O envio de lance parcelado PARA ESSE LOTE não está permitido para o seu usuário, pois não recebemos sua proposta de parcelamento PARA ESSE LOTE. Se desejar participar com lances parcelados NESSE LOTE, clique no botão "Enviar proposta agora" para ser direcionado para a tela desse lote e então enviar a proposta de parcelamento (a proposta deve ser enviada individualmente para cada lote que permitir lances parcelados). Após enviar proposta você poderá voltar nessa tela e entrar na disputa de lances parcelados.';

          this.$swal
            .fire({
              title: "Ops",
              text: texto,
              icon: "info",
              showCancelButton: true,
              cancelButtonText: "Cancelar",
              confirmButtonColor: "#4caf50",
              cancelButtonColor: "#d33",
              confirmButtonText: "Enviar proposta agora",
            })
            .then((result) => {
              if (result.value) {
                window.location.href = "/lote/" + lote.id;
              }
            });
        }
      }
    },

    selecionarIncremento(incremento, tipo_lance, lote, igualar_lance) {
      this.incremento = incremento;
      this.tipo_lance = tipo_lance;
      this.igualar_lance = igualar_lance;

      if (lote) {
        this.lote_selecionado = lote;
      }

      console.log(lote);

      this.formData.valor_minimo = this.getValorAtual(this.lote_selecionado);
      this.formData.valor_lance_atual = this.lote_selecionado.lote_lance;
      this.formData.lote_permitir_form_proposta_inferior = this.lote_selecionado.lote_permitir_form_proposta_inferior;

      //ENTRADA
      this.formData.perc_entrada = 0;
      this.formData.valor_perc_entrada = 0;

      this.formatarEntrada();

      //PARCELAS
      for (let i = 0; i < this.lote_selecionado.lote_max_parcelas; i++) {
        this.parcelas.push(i + 1);
      }

      if (
        this.lote_selecionado.lote_permitir_parcelamento == 1 &&
        this.lote_selecionado.lote_lance > 0 &&
        this.lote_selecionado.lote_ultimo_lance_parcelado == 0 &&
        tipo_lance == "parcelado"
      ) {
        let texto = "Não é mais permitido enviar lance parcelado pois já teve lance à vista para esse lote.";

        this.$swal
          .fire({
            title: "Ops",
            text: texto,
            icon: "info",
          })
          .then((result) => {});
      } else if (tipo_lance == "parcelado" && !this.lote_selecionado.proposta) {
        let texto =
          'O envio de lance parcelado PARA ESSE LOTE não está permitido para o seu usuário, pois não recebemos sua proposta de parcelamento PARA ESSE LOTE. Se desejar participar com lances parcelados NESSE LOTE, clique no botão "Enviar proposta agora" para ser direcionado para a tela desse lote e então enviar a proposta de parcelamento (a proposta deve ser enviada individualmente para cada lote que permitir lances parcelados). Após enviar proposta você poderá voltar nessa tela e entrar na disputa de lances parcelados.';
        this.$swal
          .fire({
            title: "Ops",
            text: texto,
            icon: "info",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#4caf50",
            cancelButtonColor: "#d33",
            confirmButtonText: "Enviar proposta agora",
          })
          .then((result) => {
            if (result.value) {
              window.location.href = "/lote/" + this.lote_selecionado.id;
            }
          });
      } else {
        if ((!this.lote_selecionado.lote_lance || this.lote_selecionado.lote_lance == 0) && incremento == 0) {
          console.log("Enviando lote lance 2");
          this.valor_lance = Number(this.lote_selecionado.valor_praca_atual) + Number(incremento);
          this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);
        } else if (this.lote_selecionado.lote_lance && this.lote_selecionado.lote_lance > 0 && incremento > 0) {
          console.log("Enviando lote lance 1");
          this.valor_lance = Number(this.lote_selecionado.lote_lance) + Number(incremento);
          this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);
          //INICIAL À VISTA APÓS LANCE PARCELADO
        } else if (
          this.lote_selecionado.lote_lance &&
          this.lote_selecionado.lote_lance > 0 &&
          incremento == 0 &&
          this.lote_selecionado.lote_ultimo_lance_parcelado == 1 &&
          this.tipo_lance == "a_vista"
        ) {
          console.log("Enviando lote lance 3 igualar");
          this.valor_lance = Number(this.lote_selecionado.valor_praca_atual) + Number(incremento);
          this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);

          //IGUALAR
        } else if (this.lote_selecionado.lote_lance && this.lote_selecionado.lote_lance > 0 && incremento == 0) {
          console.log("Enviando lote lance 4 igualar");
          this.valor_lance = Number(this.lote_selecionado.lote_lance) + Number(incremento);
          this.formData.valor_lance_convertido = this.toCurrency(this.valor_lance);
        }

        this.getValorTotal();

        let btn = document.getElementById("close_lance_modal");
        btn.click();
      }
    },

    selecionarLoteParaLance(lote, fav) {
      console.log("Lote selecionado");
      console.log(lote);

      //SEMPRE TRUE
      this.formData.termos = true;
      //this.formData.termos = false;

      this.lote_selecionado = lote;
      this.fav = fav;
    },

    async validarLance() {
      const result = await this.v$.$validate();

      if (result) {
        this.enviarLance();
      } else {
        console.log(this.v$);
      }
    },

    setupLeilao() {
      //this.isLoading = true;

      console.log("isLoading no setup");

      let lotes_ids = [];

      for (let i = 0; i < this.lotes.length; i++) {
        lotes_ids.push(this.lotes[i].id);
      }

      let json = {
        leilao_id: this.leilao.id,
        lotes: lotes_ids,
      };

      //this.contando = false;

      setTimeout(() => {
        socket.emit("getSetup", json);
      }, 1000);
    },

    getSetupAfter2Seconds() {
      setTimeout(() => {
        let lotes_ids = [];

        for (let i = 0; i < this.lotes.length; i++) {
          lotes_ids.push(this.lotes[i].id);
        }

        let json = {
          leilao_id: this.leilao.id,
          lotes: lotes_ids,
        };

        //console.log("GET SETUP 2 sec");
        //console.log(json);

        //console.log("Get setup 2 sec");
        socket.emit("getSetup", json);

        this.getSetupAfter2Seconds();
      }, 4000);
    },

    inicializarTempo() {
      let lotes_ids = [];

      for (let i = 0; i < this.lotes.length; i++) {
        lotes_ids.push(this.lotes[i].id);
      }

      let json = {
        leilao_id: this.leilao.id,
        lotes: lotes_ids,
      };

      socket.emit("getSetup", json);

      //ADICIONANDO CONTADOR PRA EVITAR DESATIVAR LOADER AO RECEBER "SETUP" DE LOTES DA PÁGINA ANTERIOR

      this.getSetupAfter2Seconds();

      socket.on("setup", (data) => {
        let contadorLotesNaoEncontrados = 0;

        console.log("Setup recebido qtd " + contadorLotesNaoEncontrados);
        //console.log(data);

        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            //INICIALIZANDO TODOS LOTES
            let indice = this.findLote(data[i].lote_id);

            if (indice >= 0) {
              //ATRIBUIR VALOR
              this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_avaliacao;

              if (this.praca_atual == 1) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_1;
              } else if (this.praca_atual == 2) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_2;
              } else if (this.praca_atual == 3) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_3;
              } else if (this.praca_atual == 4) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_4;
              }

              //CASO SEJA MAIS DE 1 HORA
              if (data[i].tempo >= 3600) {
                this.lotes[indice].tempo = data[i].tempo;
                this.lotes[indice].tempo_formatado = this.secondsToDhms(data[i].tempo);
              } else if (data[i].tempo >= 0) {
                this.lotes[indice].tempo = data[i].tempo;
                this.lotes[indice].tempo_formatado = moment().startOf("day").seconds(data[i].tempo).format("mm:ss");
              } else {
                this.lotes[indice].tempo = "--";
                this.lotes[indice].tempo_formatado = "--";
              }
            } else {
              contadorLotesNaoEncontrados++;
            }

            //INICIALIZANDO FAVORITOS
            indice = this.findFavoritoFromFavoritos(data[i].lote_id);

            if (indice >= 0) {
              //ATRIBUIR VALOR
              this.favoritos[indice].valor_praca_atual = this.favoritos[indice].lote_avaliacao;

              if (this.praca_atual == 1) {
                this.favoritos[indice].valor_praca_atual = this.favoritos[indice].lote_valor_1;
              } else if (this.praca_atual == 2) {
                this.favoritos[indice].valor_praca_atual = this.favoritos[indice].lote_valor_2;
              } else if (this.praca_atual == 3) {
                this.favoritos[indice].valor_praca_atual = this.favoritos[indice].lote_valor_3;
              } else if (this.praca_atual == 4) {
                this.favoritos[indice].valor_praca_atual = this.favoritos[indice].lote_valor_4;
              }

              //CASO SEJA MAIS DE 1 HORA
              if (data[i].tempo >= 3600) {
                this.favoritos[indice].tempo = data[i].tempo;
                this.favoritos[indice].tempo_formatado = this.secondsToDhms(data[i].tempo);
              } else if (data[i].tempo >= 0) {
                this.favoritos[indice].tempo = data[i].tempo;
                this.favoritos[indice].tempo_formatado = moment().startOf("day").seconds(data[i].tempo).format("mm:ss");
              } else {
                this.favoritos[indice].tempo = "--";
                this.favoritos[indice].tempo_formatado = "--";
              }
            }
          }

          //console.log("Lotes finalizados");
          //console.log(this.lotes);
        } else {
          for (let i = 0; i < this.lotes.length; i++) {
            let indice = i;

            //CASO TODAS AS PRAÇAS ESTEJAM FECHADAS
            if (!this.lotes[indice].valor_praca_atual || this.lotes[indice].valor_praca_atual == 0) {
              if (this.leilao.leilao_num_pracas == 1) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_1;
              } else if (this.leilao.leilao_num_pracas == 2) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_2;
              } else if (this.leilao.leilao_num_pracas == 3) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_3;
              } else if (this.leilao.leilao_num_pracas == 4) {
                this.lotes[indice].valor_praca_atual = this.lotes[indice].lote_valor_4;
              }
            }
          }
        }

        if (this.buscando_lotes) {
          console.log("Buscando lotes true...");
        } else if (contadorLotesNaoEncontrados > 0) {
          console.log("Loader ativado - faltando " + contadorLotesNaoEncontrados);
          console.log(this.lotes);
        } else {
          console.log("Buscando lotes false... removendo loader");
          this.isLoading = false;
        }

        this.contando = true;

        if (!this.setup_inicializado) {
          console.log("INICIALIZANDO CONTAGEM");

          //INICIAR CONTAGEM
          this.iniciarContagem();

          this.setup_inicializado = true;
        }
      });
    },

    iniciarContagem() {
      if (this.contando) {
        setTimeout(() => {
          for (let i = 0; i < this.lotes.length; i++) {
            if (this.lotes[i].tempo != "--") {
              let tempo = this.lotes[i].tempo;

              //console.log("Tempo atual ");
              //console.log(tempo);

              if (typeof tempo !== "number") {
                tempo = this.toNumber(this.lotes[i].tempo);
              }

              tempo--;

              let indice_favorito = this.findFavoritoFromFavoritos(this.lotes[i].id);

              if (tempo >= 3600) {
                this.lotes[i].tempo_formatado = this.secondsToDhms(tempo);
                this.lotes[i].tempo = tempo;
              } else if (tempo >= 0) {
                //console.log("Tempo atual " + teste);
                //console.log(tempo);

                this.lotes[i].tempo_formatado = moment().startOf("day").seconds(tempo).format("mm:ss");
                this.lotes[i].tempo = tempo;

                if (indice_favorito >= 0) {
                  this.favoritos[indice_favorito].tempo_formatado = moment().startOf("day").seconds(tempo).format("mm:ss");
                  this.favoritos[indice_favorito].tempo = tempo;
                }
              } else {
                this.lotes[i].tempo = "--";
                this.lotes[i].tempo_formatado = "--";

                if (indice_favorito >= 0) {
                  this.favoritos[indice_favorito].tempo_formatado = "--";
                  this.favoritos[indice_favorito].tempo = "--";
                }
              }
            }
          }

          this.iniciarContagem();
        }, 999);
      } else {
        console.log("Contagem encerrada ");
        return false;
      }
    },

    secondsToDhms(seconds) {
      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600 * 24));
      var h = Math.floor((seconds % (3600 * 24)) / 3600);
      var m = Math.floor((seconds % 3600) / 60);
      var s = Math.floor(seconds % 60);

      var dDisplay = d > 0 ? d + (d == 1 ? "d " : "d ") : "";
      var hDisplay = h > 0 ? h + (h == 1 ? ":" : ":") : "0:";
      var mDisplay = m > 0 ? (m >= 10 ? "" : "0") + m + ":" : "00:";
      var sDisplay = s > 0 ? (s >= 10 ? "" : "0") + s : "00";
      return dDisplay + hDisplay + mDisplay + sDisplay;
    },

    getTextFavoritos(lote) {
      let indice = this.findFavoritoFromFavoritos(lote.id);

      if (indice >= 0) {
        return "Desfavoritar";
      } else {
        return "Favoritar";
      }
    },

    getHammer(lote) {
      let indice = this.findFavoritoFromFavoritos(lote.id);

      if (indice >= 0) {
        return "https://rochaleiloes.com.br/images/hammer1.png";
      } else {
        return "https://rochaleiloes.com.br/images/hammer0.png";
      }
    },

    proximaFoto(indice_atual) {
      if (indice_atual < this.fotos.length) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    fotoAnterior(indice_atual) {
      if (indice_atual >= 0) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    selecionarLote(lote) {
      if (lote.fotos) {
        this.fotos = lote.fotos;
        this.foto_selecionada = this.fotos[0];
        this.indice_atual = 0;
      } else {
        this.fotos = [];
        this.foto_selecionada = null;
      }
    },

    getImageThumb(foto) {
      if (foto) {
        if (foto.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.thumb;
        } else if (foto.path.includes("rochaleiloes") || foto.img.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.thumb;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.thumb;
        }
      } else {
        return "/images/logo.png";
      }
    },

    getImageFoto(foto) {
      if (foto) {
        if (foto.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.img;
        } else if (foto.path.includes("rochaleiloes") || foto.img.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.img;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
        }
      } else {
        return "/images/logo.png";
      }
    },

    getClassAudit() {
      if (this.inativo) {
        return "inativo";
      } else {
        return "";
      }
    },

    selecionarFoto(foto, indice_atual) {
      this.indice_atual = indice_atual;
      this.foto_selecionada = foto;
    },

    desconectar() {
      socket.disconnect();
      this.inativo = true;
      document.getElementById("div-audit").style.pointerEvents = "none";

      this.showErrorMessageWithButtonAndReload(
        "Ops...",
        "Você foi desconectado do servidor por tempo de inatividade. Favor clicar em OK para se reconectar ao servidor."
      );
    },

    addToFavoritos(lote, indice) {
      let indice_favoritos = this.findFavoritoFromFavoritos(lote.id);

      if (indice_favoritos >= 0) {
        this.removeFromFavoritos(lote);
      } else {
        if (this.favoritos.length < this.max_favoritos) {
          let data = {
            lote_id: lote.id,
            max_favoritos: this.max_favoritos,
          };

          axios
            .post("/user/lotes/add_favorito", data)
            .then((response) => {
              //let lote = this.lotes[indice];
              //this.lotes.splice(indice, 1);

              let indice = this.findFavoritoFromFavoritos(lote.id);

              if (indice < 0) {
                this.favoritos.push(lote);
                this.showSuccessMessage("Adicionado");
              } else {
                this.showErrorMessage("Já favoritado");
              }
            })
            .catch((error) => {
              this.isLoading = false;

              this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
              console.log(error.response.data);
            });
        } else {
          this.showErrorMessageWithButton("Ops...", "O limite de favoritos para este tipo de lote é " + this.max_favoritos);
        }
      }
    },

    removeFromFavoritos(lote) {
      this.isLoading = true;
      console.log("isLoading no remove favoritos");

      let data = {
        lote_id: lote.id,
      };

      axios
        .post("/user/lotes/remove_favorito", data)
        .then((response) => {
          this.showSuccessMessage("Removido");
          window.location.reload();
        })
        .catch((error) => {
          this.isLoading = false;

          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    removerFavoritos() {
      let new_lotes = [];

      for (let i = 0; i < this.lotes.length; i++) {
        let indice = this.findFavorito(this.lotes[i].id);

        if (indice < 0) {
          new_lotes.push(this.lotes[i]);
        }
      }

      //this.lotes = new_lotes;
    },

    inicializarFavoritos() {
      /*
      for (let i = 0; i < this.lotes.length; i++) {
        let indice = this.findFavorito(this.lotes[i].id);

        if (indice >= 0) {
          this.favoritos.push(this.lotes[i]);
          this.ids_favoritos = this.ids_favoritos + this.lotes[i].id + ",";
        }
      }*/

      this.favoritos = [];

      if (this.user.lotes) {
        for (let i = 0; i < this.user.lotes.length; i++) {
          let indice = this.findLote(this.user.lotes[i].id);

          this.favoritos.push(this.lotes[indice]);
        }
      }

      this.max_favoritos = this.lotes[0].lote_tipo == "imovel" ? 5 : 10;

      this.removerFavoritos();
    },

    findFavorito(id) {
      let indice = this.user.lotes.findIndex((element) => element["id"] == id);

      return indice;
    },

    findFavoritoFromFavoritos(id) {
      if (this.favoritos && this.favoritos.length) {
        let indice = this.favoritos.findIndex((element) => element["id"] == id);

        return indice;
      } else {
        return -1;
      }
    },

    getApelidoClass(lote, fav) {
      let indice = -1;

      if (fav) {
        indice = this.findLoteFavorito(lote.id);

        if (indice >= 0) {
          lote = this.favoritos[indice];

          if (lote.lote_lance_user_id == this.user.id) {
            return "btn-green " + this.id;
          } else if (lote.classBtn == "float-red") {
            return "btn-red " + this.id;
          } else {
            return "btn-normal " + this.id;
          }
        } else {
          return "btn-normal " + this.id;
        }
      } else {
        indice = this.findLote(lote.id);

        if (indice >= 0) {
          lote = this.lotes[indice];

          if (lote.lote_lance_user_id == this.user.id) {
            return "btn-green " + this.id;
          } else if (lote.classBtn == "float-red") {
            return "btn-red " + this.id;
          } else {
            return "btn-normal " + this.id;
          }
        } else {
          return "btn-normal " + this.id;
        }
      }
    },

    getClassLote(lote, fav) {
      if (lote) {
        if (fav) {
          let indice = this.findLoteFavorito(lote.id);

          if (indice >= 0) {
            lote = this.favoritos[indice];

            if (lote.mine) {
              return lote.class + " meu_lote " + this.id;
            } else if (lote.lost) {
              return lote.class + " lote_perdido " + this.id;
            } else if (lote.animate) {
              return lote.class + " " + this.id;
            } else {
              return "" + this.id;
            }
          } else {
            return "" + this.id;
          }
        } else {
          let indice = this.findLote(lote.id);

          if (indice >= 0) {
            lote = this.lotes[indice];

            if (lote.mine) {
              return lote.class + " meu_lote " + this.id;
            } else if (lote.lost) {
              return lote.class + " lote_perdido " + this.id;
            } else if (lote.animate) {
              return lote.class + " " + this.id;
            } else {
              return lote.class + this.id;
            }
          } else {
            return "" + this.id;
          }
        }
      }
    },

    getIncrementos(lote_incrementos) {
      if (lote_incrementos) {
        let incrementos = lote_incrementos.split(";");

        incrementos.sort(this.compare);

        return incrementos;
      } else {
        return [];
      }
    },

    compare(a, b) {
      if (Number(a) < Number(b)) {
        return -1;
      }
      if (Number(a) > Number(b)) {
        return 1;
      }
      return 0;
    },

    //ATUALIZA O LOTE MANTENDO O TEMPO NA TELA
    updateLote() {
      console.log("Update lotes");

      let data = {
        user_id: this.user.id,
        leilao_id: this.leilao.id,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        ids_favoritos: this.ids_favoritos,
      };

      axios
        .post(`/user/lotes/auditorio/search`, data)
        .then((response) => {
          let lotes = response.data.lotes;

          for (let i = 0; i < lotes.length; i++) {
            let indice = this.findLote(lotes[i].id);

            if (indice >= 0) {
              lotes[i].tempo = this.lotes[indice].tempo;
              lotes[i].tempo_formatado = this.lotes[indice].tempo_formatado;
              lotes[i].valor_praca_atual = this.lotes[indice].valor_praca_atual;
            }
          }

          this.lotes = lotes;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    searchLotes(first, apenas_favoritos) {
      this.buscando_lotes = true;

      if (!apenas_favoritos) {
        this.isLoading = true;
      }

      console.log("isLoading no search lotes");

      let data = {
        user_id: this.user.id,
        leilao_id: this.leilao.id,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
        ids_favoritos: this.ids_favoritos,
      };

      console.log("Ids favs");
      console.log(this.ids_favoritos);

      axios
        .post(`/user/lotes/auditorio/search`, data)
        .then((response) => {
          this.lotes = response.data.lotes;
          this.total = response.data.total;

          console.log("Lotes");
          console.log(this.lotes);

          this.buscando_lotes = false;

          if (first) {
            this.inicializarFavoritos();

            if (!apenas_favoritos) {
              console.log("INICIALIZANDO TEMPO");
              this.inicializarTempo();
            } else {
              console.log("NÃO INICIALIZANDO TEMPO");
            }
          } else {
            this.removerFavoritos();
          }

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    findLote(id) {
      let indice = this.lotes.findIndex((element) => element["id"] == id);

      return indice;
    },

    findLoteFavorito(id) {
      let indice = this.favoritos.findIndex((element) => element["id"] == id);

      return indice;
    },

    getClass(lote) {
      let sas = "col-sm-" + this.numero + " " + this.id;

      /*
      if (lote.animate) {
        sas = sas + " shake";
      }

      console.log(sas);
      */

      return sas;
    },

    getImagePath(lote) {
      if (lote && lote.thumb) {
        if (lote.thumb.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + lote.thumb.path + "/" + lote.thumb.thumb;
        } else if (lote.thumb.path.includes("rochaleiloes") || lote.thumb.img.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + lote.thumb.path + "/" + lote.thumb.thumb;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + lote.thumb.path + "/" + lote.thumb.thumb;
        }
      } else {
        return "/images/logo.png";
      }
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    formatToCompare(date) {
      return moment(date);
    },

    getFormatedTitle(title) {
      if (title && title.length > 18) {
        return title.substring(0, 18) + "...";
      } else {
        return title;
      }
    },

    getUrlLeilao(leilao_id) {
      return "/leilao/" + leilao_id + "/lotes";
    },

    getUrlEdit(habilitacao) {
      return "/admin/habilitacao/" + habilitacao.id;
    },

    show(habilitacao) {
      this.habilitacao_selecionado = habilitacao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.searchLotes();

        window.history.replaceState(null, null, "?page=" + pagina);
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.searchLotes();

        window.history.replaceState(null, null, "?page=" + this.max_page);
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.searchLotes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.meu_ribbon {
  font-size: 15px;
  font-weight: bold;
  color: #fff;
}
.meu_ribbon {
  --f: 0.5em;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1.3;
  padding-inline: 2.5lh;
  padding-bottom: var(--f);
  border-image: conic-gradient(#0008 0 0) 51% / var(--f);
  clip-path: polygon(
    100% calc(100% - var(--f)),
    100% 100%,
    calc(100% - var(--f)) calc(100% - var(--f)),
    var(--f) calc(100% - var(--f)),
    0 100%,
    0 calc(100% - var(--f)),
    999px calc(100% - var(--f) - 999px),
    calc(100% - 999px) calc(100% - var(--f) - 999px)
  );
  transform: translate(calc((1 - cos(45deg)) * 100%), -100%) rotate(45deg);
  transform-origin: 0% 100%;
}

.regressiva {
  color: red !important;
}

.btn-red {
  color: red;
}

.btn-green {
  font-weight: bold !important;
  color: black !important;
  font-size: 12px !important;
  border: 2px solid #301904;
}

.btn-normal {
  font-weight: none !important;
  font-size: 12px !important;
  color: #4e4e4e;
}

.meu_lote {
  border: 2px solid #8cc63f;
}

.lote_perdido {
  border: 2px solid #c64a3f;
}

.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

.btn-brown {
  background-color: #301904;
  border-color: #301904;
}

.btn-brown:focus {
  background-color: #301904;
  border-color: #301904;
}

.btn-brown:before {
  background-color: #301904;
  border-color: #301904;
}

.btn-brown:hover {
  background-color: #251200;
  border-color: #251200;
}

.btn-brown:not(:disabled):not(.disabled):active,
.btn-brown:not(:disabled):not(.disabled).active,
.show > .btn-brown.dropdown-toggle {
  color: #fff;
  background-color: #5c3818;
  border-color: #5c3818;
}

.btn-brown-yellow {
  background-color: #aa7c39;
  border-color: #aa7c39;
}

.btn-brown-yellow:focus {
  background-color: #aa7c39;
  border-color: #aa7c39;
}

.btn-brown-yellow:before {
  background-color: #aa7c39;
  border-color: #aa7c39;
}

.btn-brown-yellow:hover {
  background-color: #836b42;
  border-color: #836b42;
}

.btn-brown-yellow:not(:disabled):not(.disabled):active,
.btn-brown-yellow:not(:disabled):not(.disabled).active,
.show > .btn-brown-yellow.dropdown-toggle {
  color: #fff;
  background-color: #783a13;
  border-color: #783a13;
}

.inativo {
  opacity: 0.1;
}

.realizado {
  text-decoration: line-through;
}

.current-page {
  background-color: #301904 !important;
  color: white !important;
}

.modal-content {
  width: 1000px;
  margin-left: -200px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -20px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
